import { Outlet } from "react-router-dom";
import ChatsPage from "./ChatsPage";

export const adminChatsRoutes = [
  {
    path: "chats",
    element: Outlet,
    children: [
      {
        path: "",
        element: ChatsPage,
      },
    ],
  },
];
